import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ComposerPage } from "@/features/content/composer";

const search = z.object({ scheduledAt: z.string().optional(), caption: z.string().optional(), mediaId: z.string().optional(), eventId: z.string().uuid().optional() }); // eventId: "Create post for this day" (calendar)

export const Route = createFileRoute("/_app/content/compose")({
  validateSearch: search,
  head: () => ({ meta: [{ title: "Create post · Malfak" }] }),
  component: Compose,
});

function Compose() {
  const s = Route.useSearch();
  // remount when arriving with new prefill (e.g. from the calendar or AI Studio)
  return <ComposerPage key={`${s.scheduledAt ?? ""}|${s.caption ?? ""}|${s.mediaId ?? ""}|${s.eventId ?? ""}`} search={s} />;
}
